module.exports = __webpack_public_path__ + "static/media/wrong.7863d4dc.png";